export default __webpack_public_path__ + "static/everett-medium-webfont-d62eba1fb3dab60b37ca850f1b587667.woff";